import { TrackRecordV2 } from '@roc/feature-track-record-v2';
import { observer } from 'mobx-react';
import { useUserStore } from '@roc/feature-app-core';
import { useBorrowerBaseballCardStore } from '../../hooks/useBorrowerBaseballCardStore';
import { useBorrowerTrackRecordStore } from '../../hooks/useBorrowerTrackRecordStore';

const noop = () => {};

export const TrackRecordInfoTab = observer(({ borrower }) => {
  const { borrowerBaseballCardStore } = useBorrowerBaseballCardStore();
  const { borrowerTrackRecordStore } = useBorrowerTrackRecordStore();
  const { userStore } = useUserStore();

  if (!borrower?.borrowerId) {
    return null;
  }

  borrowerBaseballCardStore.currentBorrower = borrower.borrowerId;
  borrowerBaseballCardStore.loanId = null;
  // TrackRecordV2 now loads experience data via loadFromOverview(), lazily.

  return (
    <TrackRecordV2
      onClose={noop}
      borrowerName={borrower.fullName || `${borrower.firstName ?? ''} ${borrower.lastName ?? ''}`.trim()}
      store={borrowerTrackRecordStore}
      borrowerId={borrower.borrowerId}
      isInternal={userStore.isNportalUser}
      hideTaskTitle
      // The borrower dialog already scrolls; let V2 grow with its content (single scroll).
      maxHeight="auto"
    />
  );
});
